(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-list-alpha"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const wrappers = document.querySelectorAll('.collection-list-alpha__inner');
  
  wrappers.forEach(wrapper => {
    const svg = wrapper.querySelector('.chevron');
    const content = wrapper.querySelector('.collection-list-alpha__inner__content');
    
    wrapper.addEventListener('click', () => {
      if (wrapper.classList.contains('content-hovered')) {
        // If the class is already added (second click), remove the class and collapse content
        wrapper.classList.remove('content-hovered');
        svg.style.transform = 'rotate(0deg)';
        content.style.maxHeight = '0';
      } else {
        // If the class is not present (first click), add the class and expand content
        wrapper.classList.add('content-hovered');
        svg.style.transform = 'rotate(180deg)';
        content.style.maxHeight = '100%'; // Adjust max-height as needed
      }
    });
  });
});

  } catch(e) { console.error(e); }
})();
})();
